import React, { useEffect, useState } from 'react';
import { Hero } from './components/sections/Hero';
import { Results } from './components/sections/Results';
import { Objections } from './components/sections/Objections';
import { WhatsIncluded } from './components/sections/WhatsIncluded';
import { Testimonials } from './components/sections/Testimonials';
import { Offer } from './components/sections/Offer';
import { Guarantee } from './components/sections/Guarantee';
import { FinalCTA } from './components/sections/FinalCTA';
import { CTAButton } from './components/ui/CTAButton';
import { CountdownTimer } from './components/ui/CountdownTimer';
import { PurchaseNotification } from './components/ui/PurchaseNotification';
export function App() {
  const [showStickyCTA, setShowStickyCTA] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      const offerSection = document.getElementById('oferta');
      const offerPosition = offerSection ? offerSection.offsetTop : Infinity;
      if (window.scrollY > 600 && window.scrollY < offerPosition - window.innerHeight + 200) {
        setShowStickyCTA(true);
      } else {
        setShowStickyCTA(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <div className="min-h-screen bg-navy font-sans text-beige" data-id="element-0">
      <CountdownTimer data-id="element-1" />

      <Hero data-id="element-2" />
      <Testimonials data-id="element-3" />
      <Results data-id="element-4" />
      <Objections data-id="element-5" />
      <WhatsIncluded data-id="element-6" />
      <Offer data-id="element-7" />
      <Guarantee data-id="element-8" />
      <FinalCTA data-id="element-9" />

      <PurchaseNotification data-id="element-10" />

      {/* Sticky Mobile CTA */}
      <div className={`
          fixed bottom-0 left-0 right-0 p-4 bg-navy/95 backdrop-blur-md border-t border-gold/20
          transform transition-transform duration-300 z-50 md:hidden
          ${showStickyCTA ? 'translate-y-0' : 'translate-y-full'}
        `} data-id="element-11">
        <CTAButton fullWidth className="shadow-lg text-sm" data-id="element-12">
          QUIERO MI MUSIC PRO KIT AHORA
        </CTAButton>
      </div>
    </div>;
}